// null is variable in the data returned from the django api, but the api
// filters expect the value 'variable' so we convert it for use in the front end.
export enum DjangoFontPosture {
    'Variable' = null,
    'Roman' = '0',
    'Italic' = '1',
}

export function mapDjangpoFontPostureToFontPosture(
    posture: DjangoFontPosture
): FontPosture {
    if (posture == '0' || posture == 0) return 0;
    if (posture == '1' || posture == 1) return 1;
    return 'variable';
}

// TS doesn't do a good job with heterogeneous enums, so
// we use a union type here instead. The drawback is we need
// to keep FONT_POSTURES and FONT_POSTURE_OPTIONS in sync manually.
// and we don't get the reverse look up for labels.

// on the upside, no runtime generation is need so we can as const everything.
// we should probably do this instead of enums so the code is consistent and we
// should get a little startup time improvement.

export const FONT_POSTURES = [0, 1, 'variable'] as const;

export type FontPosture = (typeof FONT_POSTURES)[number];

export function isFontPosture(value: unknown): value is FontPosture {
    return (
        (typeof value == 'number' || typeof value == 'string') &&
        FONT_POSTURES.includes(value as FontPosture)
    );
}

export const FONT_POSTURE_OPTIONS = [
    { value: 0, label: 'Roman' },
    { value: 1, label: 'Italic' },
    { value: 'variable', label: 'Variable' },
] as const;
